module.exports = __webpack_public_path__ + "img/30f7.a0f48f41.jpg";